import { useTranslation } from '@/i18n/useTranslation';

export function FullPageSpinner({ label }: { label?: string }) {
  const { t } = useTranslation();
  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 'var(--space-3)',
        height: '100vh',
        color: 'var(--color-text-secondary)',
      }}
    >
      <div className="spinner" aria-hidden="true" />
      <span>{label ?? t('Loading…')}</span>
      <style>{`
        .spinner {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          border: 4px solid var(--color-border);
          border-top-color: var(--color-teal-500);
          animation: spin 0.8s linear infinite;
        }
        @keyframes spin { to { transform: rotate(360deg); } }
        @media (prefers-reduced-motion: reduce) {
          .spinner { animation: none; }
        }
      `}</style>
    </div>
  );
}
